import { WidgetDefinition } from '../models/WidgetDefinition';

export const TableWidgetDefinition: WidgetDefinition = {
    baseType: 'table',
    group: 'Others',
    hasImage: true,
    highlights: ['Values of identifiers versus time shown as numbers', 'You can aggregate values, include a mini-trend or show alarms and logbook entries'],
    icon: 'fa-table',
    sortingOrder: 1100,
    title: 'Table',
    type: 'table'
};